import { AlsBase, getDefaultAlsBase } from './AlsBase'
import { AlsUser, getDefaultAlsUser } from './AlsUser'


export interface AlsSejour extends AlsUser {
    
    usrEmail: string
    inCours: boolean | null
    toCome: boolean | null
    
}

export const getDefaultAlsSejour = (commit:boolean=true):AlsSejour => {
    const today = new Date()      
    today.setHours(0,0,0,0)      
    return {
        ...getDefaultAlsUser(commit),
        usrEmail:'',
        inCours:null,
        toCome:null
    }
}

export const cleanAlsSejour = (filter:AlsSejour) => {
    if(!filter) return    
    if(!filter.id) delete filter.id
}
